/**
 * @copyright       Palace Resorts
 * @description     Mensajes para la sección de NotFound.
 * @author          Roberto Pérez Guzmán
 * @creationDate    06 de Mayo del 2021
 */

export default {
  fallbackLocale: 'ES',
  locale: 'ESP',
  messages: {
    'ESP': {
        'lblTitle': 'Recurso no disponible',
        'lblDescription': '<strong class="accent--text">Error 404</strong>. El recurso solicitado no existe.'
    },
    'ENG': {
      'lblTitle': 'Not found',
      'lblDescription': '<strong>404 error</strong>. Requested resource was not found.'
    }
  }
}
